import { numeral } from '../numeral';

numeral.register('format', 'percentage', {
	regexps: {
		format: /(%)/,
		unformat: /(%)/
	},

	format(value: number, format: string, roundingFunction: (x: number) => number) {
		const { _ } = numeral;
		const space = format.includes(' %') ? ' ' : '';
		let output;

		if (numeral.options.scalePercentBy100) {
			value = value * 100;
		}

		// check for space before %
		format = format.replace(/\s?%/, '');

		output = _.numberToFormat(value, format, roundingFunction);

		if (output.includes(')')) {
			output = output.split('');

			output.splice(-1, 0, `${space}%`);

			output = output.join('');
		} else {
			output = `${output + space}%`;
		}

		return output;
	},

	unformat(s: string) {
		const n = numeral._.stringToNumber(s);
		if (n && numeral.options.scalePercentBy100) {
			return n * 0.01;
		}
		return n;
	}
});
